var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-warning-secondary warning_wrapper"},[_c('p',{staticClass:"mb-2 font-bold",domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.subtitle)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }